import { Box, Grid, makeStyles, createStyles, Theme } from '@material-ui/core';
import { useMedidataComponent } from '../../util';
import { InfoCard } from '@backstage/core-components';

// Mostly copied from
// https://github.com/backstage/backstage/blob/2262fe19c925e25aae9c3559b833476e866a9ff1/plugins/org/src/components/Cards/Group/MembersList/MembersListCard.tsx#L49-L62
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.shadows[2],
      borderRadius: '4px',
      overflow: 'hidden',
      position: 'relative',
      margin: theme.spacing(1, 1, 1),
      flex: '1',
      minWidth: '0px',
      wordBreak: 'break-word',
    },
  }),
);

const AliasComponent = ({ alias }: { alias: string }) => {
  const classes = useStyles();
  return (
    <Grid item md={4}>
      <Box className={classes.card}>
        <Box
          display="flex"
          flexDirection="column"
          m={1}
          alignItems="center"
          justifyContent="center"
          word-wrap="break-word"
        >
          <Box textAlign="center">{alias}</Box>
        </Box>
      </Box>
    </Grid>
  );
};

export const AliasesCard = () => {
  const aliases = useMedidataComponent().mdsol.aliases;

  if (!aliases) {
    return null;
  }

  return (
    <InfoCard>
      <Grid container>
        {aliases.map((alias, i) => (
          <AliasComponent alias={alias} key={i} />
        ))}
      </Grid>
    </InfoCard>
  );
};
